import { StatsTeam, ValueOpt } from "best-common-react";

export const getTeamOption = (teamId: number | string, teamOptions: ValueOpt<StatsTeam>[]): ValueOpt<StatsTeam> =>
  //@ts-ignore
  teamId ? teamOptions.find((opt: ValueOpt<StatsTeam>) => opt.value.id === teamId) : { label: "All", value: {} };
